import React, { useState, useEffect } from "react";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import TextField from "@mui/material/TextField";

interface DatePickerTarjetaProps {
  fullWidth?: boolean;
  onChange?: (date: Date | null) => void;
  onKeyDown?: (event: React.KeyboardEvent) => void;
  value?: Date | string | null;
  minDate?: Date | string;
  maxDate?: Date | string;
  className?: string;
  label?: React.ReactNode;
  id?: string;
  error?: boolean;
  helperText?: React.ReactNode;
  onBlur?: () => void;
  reference?: React.Ref<HTMLInputElement>;
}

const DatePickerTarjeta: React.FC<DatePickerTarjetaProps> = ({
  fullWidth,
  onChange,
  onKeyDown,
  value,
  minDate,
  maxDate,
  className,
  label,
  id,
  error,
  helperText,
  onBlur,
  reference,
}) => {
  const [selectedDate, setSelectedDate] = useState(value);

  const handleDateChange = (date: Date | null) => {
    setSelectedDate(date);
    if (onChange) onChange(date);
  };

  const handleBlur = () => {
    if (onBlur) onBlur();
  };

  useEffect(() => {
    setSelectedDate(value);
  }, [value]);

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePicker
        label={label}
        value={selectedDate}
        onChange={handleDateChange}
        views={["year", "month"]}
        openTo="month"
        inputFormat="MM/yy"
        minDate={minDate as any}
        maxDate={maxDate as any}
        renderInput={(params: any) => (
          <TextField
            {...params}
            fullWidth={fullWidth}
            margin="normal"
            id={id}
            error={!!error}
            helperText={helperText}
            onBlur={handleBlur}
            onKeyDown={onKeyDown}
            className={className}
            inputRef={reference}
          />
        )}
      />
    </LocalizationProvider>
  );
};

export default DatePickerTarjeta;
